import { Radio } from '@shared/ui/radio/radio'
import { Avatar, Button, Divider, Flex, Form, Input, Typography } from 'antd'
import { Popup } from 'antd-mobile'
import { useMemo, useState } from 'react'
import { Virtuoso } from 'react-virtuoso'
import './styled.css'

const { Title } = Typography

type SearchPopupProps = {
    name?: string
    visible: boolean
    title?: string
    onClose: () => void
    onClick?: () => void
    onSelect: (value: string | number) => void
    renderItem?: () => void
    data: { value: string | number; label: string; avatarUrl?: string; hint?: string }[]
    avatar?: boolean
}

const SearchPopup = ({ visible, onClose, onClick, data, name, title, avatar, onSelect }: SearchPopupProps) => {
    const [searchTerm, setSearchTerm] = useState('')

    const filteredData = useMemo(() => {
        if (!searchTerm) return data
        return data.filter(
            (item) =>
                item.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.hint?.toLowerCase().includes(searchTerm.toLowerCase())
        )
    }, [data, searchTerm])

    return (
        <Popup
            className={'search-popup-kit'}
            visible={visible}
            onMaskClick={onClose}
            bodyStyle={{ borderRadius: '12px' }}
        >
            {title && (
                <Title level={3} style={{ margin: 0, padding: '23px 23px 0 23px' }}>
                    {title}
                </Title>
            )}
            <Form.Item
                style={{
                    height: '70vh',
                    overflowY: 'scroll',
                    padding: '20px 20px 0 20px',
                    scrollbarWidth: 'none', // Для Firefox
                    msOverflowStyle: 'none', // Для IE и Edge
                    '&::WebkitScrollbar': {
                        display: 'none' // Для Chrome, Safari и Opera
                    }
                }}
                name={name}
                required={false}
                rules={[{ required: true, message: 'Обязательное поле' }]}
            >
                <Input
                    size="large"
                    placeholder="Поиск..."
                    allowClear
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ marginBottom: '14px' }}
                />
                <Radio.Group style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <Virtuoso
                        style={{ height: 'calc(70vh - 72px)' }}
                        totalCount={filteredData.length}
                        itemContent={(index) => {
                            const c = filteredData[index]
                            return (
                                <Flex key={c.value} align="center" gap={14}>
                                    {avatar && <Avatar size={40} src={c.avatarUrl} />}
                                    <div style={{ flex: 1 }}>
                                        <Radio
                                            onClick={() => onSelect(c.value)}
                                            style={{
                                                fontSize: 18,
                                                display: 'flex',
                                                flexDirection: 'row-reverse',
                                                justifyContent: 'space-between',
                                                padding: '12px 0',
                                                alignItems: 'center',
                                                width: '100%'
                                            }}
                                            value={c.value}
                                        >
                                            {c.hint && <div>{c.hint}</div>}
                                            <div>{c.label}</div>
                                        </Radio>
                                        <Divider className="custom-divider" />
                                    </div>
                                </Flex>
                            )
                        }}
                    />
                </Radio.Group>
            </Form.Item>
            <div
                style={{
                    margin: '0 20px',
                    padding: '0 0 16px 0',
                    borderTop: '1px solid #f0f0f0',
                    background: '#fff',
                    position: 'sticky',
                    bottom: 0
                }}
            >
                <Button style={{ borderRadius: 10, height: 52 }} type="primary" onClick={onClick} block size="large">
                    Сохранить
                </Button>
            </div>
        </Popup>
    )
}

export default SearchPopup
